import { logger, LogLevel, openCenteredPopup } from '@/shared/utils';

interface ShareParams {
  url: string;
  title?: string;
}

export const openTwitterSharePopup = ({ url, title }: ShareParams) => {
  const encodedURI = encodeURIComponent((title ? title + '\n' : '') + url);
  const shareURL = 'https://twitter.com/intent/tweet?text=' + encodedURI;

  openCenteredPopup(shareURL, {
    width: 600,
    height: 500,
    windowName: 'twitter',
  });
};

export const openFacebookSharePopup = ({ url }: ShareParams) => {
  const shareURL =
    'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);

  openCenteredPopup(shareURL, {
    width: 570,
    height: 400,
    windowName: 'facebook',
  });
};

export const openNaverSharePopup = ({ url, title }: ShareParams) => {
  const shareURL = `http://share.naver.com/web/shareView.nhn?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title ?? '')}`;

  openCenteredPopup(shareURL, { width: 575, height: 450, windowName: 'naver' });
};

export const openLinkedInSharePopup = ({ url }: ShareParams) => {
  const shareURL =
    'https://www.linkedin.com/shareArticle?mini=true&url=' +
    encodeURIComponent(url);

  openCenteredPopup(shareURL, {
    width: 570,
    height: 660,
    windowName: 'linkedin',
  });
};

export const openNavigatorShare = (shareData: ShareParams) => {
  if (!navigator.share) {
    alert('현재 브라우저는 공유 기능을 지원하지 않습니다.');
  }

  try {
    navigator.share(shareData);
  } catch (error) {
    logger(LogLevel.ERROR, error, {
      message: 'openNavigatorShare error',
      detail: {
        shareData,
      },
    });
  }
};
